import React, { ReactElement } from 'react';
import { Col, Row } from 'reactstrap';
import Tabs from '../../../../../components/HearingAndAppealTabs/HearingAndAppealTabs.component';
import { HEARING_TABS } from '../../../../../utils/case-utils';
import { Formik, FormikProps, FormikValues } from 'formik';
import {
  filterFormData,
  getFormDataFromCaseData,
  WorkflowComponentProps,
} from '../../../../WorkflowContainer/workflow-utils';
import { WorkFlowFooter } from '../../../../../components/workflowFooter/WorkFlowFooter';
import { AppealHearingExternalRepresentationSubmissionsForm } from './AppealHearingExternalRepresentationSubmissionsForm';

export const AppealHearingExternalRepresentationSubmissions: React.FC<WorkflowComponentProps> = (
  props: WorkflowComponentProps,
) => {
  const { caseData } = props.data;
  const fields = {
    appeal_hearing_externalRepresentationApplicationEmployeeSubmissionDocuments: 'array',
    appeal_hearing_externalRepresentationApplicationEmployerResponseDocuments: 'array',
  };

  const initialValues = getFormDataFromCaseData(fields, caseData);

  const getFormValuesForSubmission = (values: FormikValues): Record<string, any> => {
    const formValues = { ...values };
    formValues.appeal_hearing_externalRepresentationApplicationEmployeeSubmissionDocuments = JSON.stringify(
      values.appeal_hearing_externalRepresentationApplicationEmployeeSubmissionDocuments,
    );
    formValues.appeal_hearing_externalRepresentationApplicationEmployerResponseDocuments = JSON.stringify(
      values.appeal_hearing_externalRepresentationApplicationEmployerResponseDocuments,
    );
    return filterFormData(formValues, fields);
  };

  const submitValues = (formValues: FormikValues): void => {
    props.data.flowableFunctions.onNext(getFormValuesForSubmission(formValues));
  };

  return (
    <div className="content">
      <h4 className="text-h4 text-capitalize font-weight-500 mt-3">
        {' '}
        {props.data.caseData.isAppeal ? 'Appeal' : ''} Hearing preparations
      </h4>
      <Row>
        <Col md={12}>
          <Tabs page={5} tabs={HEARING_TABS} />
        </Col>
      </Row>
      {/*<h5 className="text-h5 text-capitalize font-weight-500 mt-3">*/}
      {/*  Decide on Employee's application for external representation*/}
      {/*</h5>*/}
      <h4 className="text-h4 text-capitalize font-weight-500 mt-3">Record the respective parties' submissions</h4>
      <Formik initialValues={initialValues} enableReinitialize onSubmit={submitValues}>
        {({ values, handleSubmit }: FormikProps<FormikValues>): ReactElement => (
          <>
            <AppealHearingExternalRepresentationSubmissionsForm
              data={props.data}
              getFormValuesForSubmission={getFormValuesForSubmission}
            />
            <WorkFlowFooter
              data={props.data}
              onNext={handleSubmit}
              onCancel={() => console.log('cancel')}
              onSaveAndClose={(): void => {
                props.data.flowableFunctions.onSaveAndClose(values);
              }}
            />
          </>
        )}
      </Formik>
    </div>
  );
};
